import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';

import { LoadingService } from '../../../core/services/loading.service';

@Component({
    selector: 'wf-loading-mask',
    templateUrl: './loading-mask.component.html',
    styleUrls: ['./loading-mask.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoadingMaskComponent {
  readonly loading = inject(LoadingService).loading;
}
